import { StateCreator } from 'zustand'
//import { InterJSON, Magazine } from '../../Datatypes'

type State = {
    offlineDuration: number,
    favouriteEdition: string,
    notificationSettings: string,
};

export interface UserSettingsZustandSlice {
    offlineDuration: number,
    favouriteEdition: string,
    notificationSettings: string,

    updateOfflineDuration: (offlineDuration: State['offlineDuration']) => void
    updateFavouriteEdition: (favouriteEdition: State['favouriteEdition']) => void
    updateNotificationSettings: (notificationSettings: State['notificationSettings']) => void

    _hasHydrated: boolean
    setHasHydrated: (state: any) => void
}

export const createUserSettingsZustandSlice: StateCreator<UserSettingsZustandSlice> = (set, get) => ({
    offlineDuration: 99,
    favouriteEdition: 'DLZ',
    notificationSettings: '',

    updateOfflineDuration: (offlineDuration) => set(() => ({ offlineDuration: offlineDuration })),
    updateFavouriteEdition: (favouriteEdition) => set(() => ({ favouriteEdition: favouriteEdition })),
    updateNotificationSettings: (notificationSettings) => set(() => ({ notificationSettings: notificationSettings })),

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});

